import React, { FC, PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';

import { open, switchMode } from 'src/explore/compositions/Auth/actions';

import Button from '../../../../../../atoms/Button';

interface AuthenticationProps {
  className?: string;
}

const Authentication: FC<PropsWithChildren<AuthenticationProps>> = ({ children, className }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch( switchMode( 'login' ));
    dispatch( open());
  };

  return (
    <Button ariaLabel="Account" className={className} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default Authentication;
